import React from "react";
import { TermMiniCalendar } from "./DayCell";
import { findCurrentTerm } from "helpers/calendar/calendarTerms";

const TermGrid = ({
  config,
  autoDraftDates,
  closedDates,
  closureLabels,
  today,
  onSelectDay,
  selectedDate,
}) => {
  const currentTerm = findCurrentTerm(config.terms, today);

  return (
    <div className="calendar-term-grid" role="region" aria-label="Terms by season">
      {config.terms.map((term) => (
        <TermMiniCalendar
          key={term.id}
          term={term}
          config={config}
          autoDraftDates={autoDraftDates}
          closedDates={closedDates}
          closureLabels={closureLabels}
          today={today}
          isCurrent={currentTerm?.id === term.id}
          onSelectDay={onSelectDay}
          selectedDate={selectedDate}
        />
      ))}
    </div>
  );
};

export default TermGrid;
